<div
  data-auto-id="redirectToClick"
  class="nav-item"
  [class.nav-item_is-collapsed]="isSideBarCollapsed()"
  (mousedown)="redirectTo($event)"
  routerLinkActive="nav-item_is-active"
  appAddClassModifier
>
  <a
    data-auto-id="setIsSideNavBarVisibleClick"
    [routerLink]="navItem().link"
    class="nav-item__container"
    (click)="setIsSideNavBarVisible(false)"
  >
    <div class="nav-item__icon-container">
      <img
        class="nav-item__icon nav-item__icon_is-default"
        [src]="getIconUrl()"
        alt=""
      />
      <img
        class="nav-item__icon nav-item__icon_is-active"
        [src]="getActiveIconUrl()"
        alt=""
      />
    </div>
    <div class="nav-item__label">
      {{ navItem().name }}
    </div>
  </a>
</div>
